<template>
  <div class="profile">
    <BioComponent :extra-bio="extraBio" />
    <QBtn
      v-if="canDownloadResume"
      class="btn-navigation full-width q-mt-md"
      color="secondary"
      icon="icon-f-download"
      :label="$t('ETAB.BUTTONS.@DOWNLOAD_RESUME')"
      no-caps
      @click="downloadResume"
    />
    <MotivationComponent :extra="extraBio" />
    <LanguagesComponent :languages="extraLanguages" />
    <ExperiencesComponent :experiences="extraExperiences" />
    <SkillComponent :skills="extraSkills" :is-haccp-certified="extraHaccpCertif" />
    <CoursesComponent :courses="extraCourses" />
  </div>
</template>

<script setup>
  import {
    GETTER_EXTRA_GET_BIO,
    GETTER_EXTRA_GET_LANGUAGE,
    GETTER_EXTRA_GET_EXTRA_SKILLS,
    GETTER_EXTRA_GET_HACCP_CERTIF,
    GETTER_EXTRA_GET_COURSES,
    GETTER_RECRUITMENT_GET_CURRENT,
    GETTER_EXTRA_GET_CURRENT,
    GETTER_EXTRA_GET_EXPERIENCES,
  } from "@etab/stores/types";
  import { ExtraService } from "@core/services";
  import { useExtraStore } from "@etab/stores/extra";
  import { useRecruitmentStore } from "@etab/stores/recruitment";
  import { computed } from "vue";
  import { isWeb } from "@core/plugins/mobile";

  import BioComponent from "@etab/components/extra/profile/Bio.component.vue";
  import MotivationComponent from "@etab/components/extra/profile/Motivation.component.vue";
  import LanguagesComponent from "@etab/components/extra/profile/Languages.component.vue";
  import SkillComponent from "@etab/components/extra/profile/Skills.component.vue";
  import CoursesComponent from "@etab/components/extra/profile/Courses.component.vue";
  import ExperiencesComponent from "@etab/components/extra/profile/Experiences.component.vue";
  import { useRoute } from "vue-router";

  const extraStore = useExtraStore();
  const route = useRoute();

  const extraBio = computed(() => extraStore[GETTER_EXTRA_GET_BIO]);
  const extraLanguages = computed(() => extraStore[GETTER_EXTRA_GET_LANGUAGE]);
  const extraSkills = computed(() => extraStore[GETTER_EXTRA_GET_EXTRA_SKILLS]);
  const extraHaccpCertif = computed(() => extraStore[GETTER_EXTRA_GET_HACCP_CERTIF]);
  const extraCourses = computed(() => extraStore[GETTER_EXTRA_GET_COURSES]);
  const extra = computed(() => extraStore[GETTER_EXTRA_GET_CURRENT]);
  const recruitment = useRecruitmentStore()[GETTER_RECRUITMENT_GET_CURRENT];
  const extraExperiences = computed(() => extraStore[GETTER_EXTRA_GET_EXPERIENCES]);

  const demandId = computed(() => route.params.demandId);
  const canAccessContactInformations = ExtraService.canAccessContactInformations({
    extra: extra.value,
    recruitment,
  });
  const canDownloadResume = computed(() => isWeb && canAccessContactInformations);

  const downloadResume = () => {
    const extraId = extra.value.getId();
    const extraIdentity = extra.value.getIdentity();
    return ExtraService.downloadResume({ extraId, demandId: demandId.value, extraIdentity });
  };
</script>
